// src/pages/IndoorMap/LocationCard.jsx
import React from "react"

const LocationCard = ({ location, tag }) => {
  if (!location) return null
  return (
    <div className="location-card">
      {/* <div className="location-card-image">
        <img src={location.image} alt={location.name} />
      </div> */}
      <div className="location-card-body">
        <span className="location-card-tag">{tag}</span>
        <h3 className="location-card-name">{location.name}</h3>
        <p className="location-card-desc">{location.description}</p>
      </div>
    </div>
  )
}

export default LocationCard